import { toast } from "react-toastify";

const bookingToastOptions = {
  position: "top-center",
  autoClose: 5000,
  hideProgressBar: false,
  closeOnClick: true,
  closeButton: true,
  pauseOnHover: true,
  draggable: true,
  className: "booking-toast booking-toast--success",
  bodyClassName: "booking-toast__body",
  progressClassName: "booking-toast__progress",
};

const bookingInfoToastOptions = {
  ...bookingToastOptions,
  className: "booking-toast booking-toast--info",
};

const bookingErrorToastOptions = {
  ...bookingToastOptions,
  autoClose: 6000,
  className: "booking-toast booking-toast--error",
};

export const showBookingSuccessToast = (message) =>
  toast.success(message, bookingToastOptions);

export const showBookingInfoToast = (message) =>
  toast.info(message, bookingInfoToastOptions);

export const showBookingErrorToast = (message) =>
  toast.error(message, bookingErrorToastOptions);
